import { Url } from 'url'
import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type Subcategory = { id: number; category: number; name: string; description: string; created_at: Date; updated_at: Date; }

export function useGetSubcategories() {
  return useFetch<Subcategory[]>(getAbsoluteServerUrl('/subcategories'), { responseType: 'json' }, [])
}
